// components
import { Box, Paper, styled } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import { StyledTypographyTruncate } from 'components/shared/Typography/Typography.styles';

export const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  height: '100%',
  width: '100%',
  gap: theme.spacing(4),

  '.single-tab-panel:not(.show-scrollbar) .rbc-time-content': {
    scrollbarColor: 'transparent transparent',
    '&::-webkit-scrollbar': {
      background: 'transparent',
      width: '8px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'transparent'
    }
  }
}));

export const Panel = styled(Paper, {
  shouldForwardProp: (prop: string) => !['flatTop', 'minWidth'].includes(prop)
})<{
  flatTop?: boolean;
  hidden?: boolean;
  minWidth?: number | string;
  width?: number | string;
}>(({ theme, flatTop, hidden, minWidth }) => ({
  display: hidden ? 'none' : 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: minWidth ? minWidth : 'inherit',
  height: '100%',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: flatTop ? '0 0 28px 28px' : 28,
  overflowY: 'clip',
  transitionDuration: `${theme.transitions.duration.shortest}ms`,
  boxShadow: 'none',
  boxSizing: 'border-box'
}));

export const ScrollContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: theme.spacing(2)
}));

export const CustomIcon = styled(Icon)(({ theme }) => ({
  width: '16px',
  height: '16px',
  padding: theme.spacing(2),
  color: theme.vars.palette.text.secondary,
  fontSize: theme.typography.h6.fontSize
}));

export const ButtonIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.vars.shape.borderRadius,
    cursor: 'pointer'
  }
}));

export const IconCollectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const IconContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['iconColor', 'iconSize', 'customIconSize', 'colorAsBackground'].includes(
      prop
    )
})<{
  iconColor?: string;
  iconSize?: 'SMALL' | 'MEDIUM' | 'LARGE';
  customIconSize?: number;
  colorAsBackground?: boolean;
}>(
  ({
    theme,
    iconColor,
    iconSize = 'SMALL',
    customIconSize,
    colorAsBackground
  }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),

    svg: {
      // NOTE: toggle this if showing unique colors for each appointment
      // color: theme.palette.primary.main,
      // color: 'var(--appointment-darker)',
      ...(colorAsBackground && {
        width: customIconSize
          ? `${customIconSize}px`
          : iconSize === 'SMALL'
          ? '12px'
          : iconSize === 'MEDIUM'
          ? '20px'
          : '28px',
        height: customIconSize
          ? `${customIconSize}px`
          : iconSize === 'SMALL'
          ? '12px'
          : iconSize === 'MEDIUM'
          ? '20px'
          : '28px',
        backgroundColor: iconColor,
        color: '#fff',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(2)
      }),
      ...(!colorAsBackground && {
        width: customIconSize
          ? `${customIconSize}px`
          : iconSize == 'SMALL'
          ? '16px'
          : iconSize == 'MEDIUM'
          ? '24px'
          : '32px',
        height: customIconSize
          ? `${customIconSize}px`
          : iconSize == 'SMALL'
          ? '16px'
          : iconSize == 'MEDIUM'
          ? '24px'
          : '32px',
        color: iconColor
      })
    }
  })
);

export const IconLabel = styled(StyledTypographyTruncate)(() => ({
  width: 'fit-content'
}));
